<template>
    <div class="contact-float">
        <div class="contact-btn-group">
            <!-- FaceBook -->
            <el-popover trigger="hover" placement="left" :offset="[60, 0]" width="auto">
                <template #reference>
                    <div class="contact-btn facebook">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z"/>
                        </svg>
                    </div>
                </template>
                <div class="contact-popover">
                    <div class="contact-icon facebook">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z"/>
                        </svg>
                    </div>
                    <div class="contact-info">
                        <span class="contact-label">FaceBook</span>
                        <a href="https://www.facebook.com/profile.php" target="_blank" class="contact-value">https://www.facebook.com/profile.php</a>
                    </div>
                    <button class="copy-btn" @click.stop="copyToClipboard('https://www.facebook.com/profile.php')">{{ langrage.copy }}</button>
                </div>
            </el-popover>
            
            <!-- Telegram -->
            <el-popover trigger="hover" placement="left" :offset="[60, 0]" width="auto">
                <template #reference>
                    <div class="contact-btn tg">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
                        </svg>
                    </div>
                </template>
                <div class="contact-popover">
                    <div class="contact-icon tg">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
                        </svg>
                    </div>
                    <div class="contact-info">
                        <span class="contact-label">TELEGRAM</span>
                        <a href="http:TELEGRAM@micproxy.com" target="_blank" class="contact-value">http:TELEGRAM@micproxy.com</a>
                    </div>
                    <button class="copy-btn" @click.stop="copyToClipboard('http:TELEGRAM@micproxy.com')">{{ langrage.copy }}</button>
                </div>
            </el-popover>

            <!-- WhatsApp -->
            <el-popover trigger="hover" placement="left" :offset="[60, 0]" width="auto">
                <template #reference>
                    <div class="contact-btn whatsapp">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
                        </svg>
                    </div>
                </template>
                <div class="contact-popover">
                    <div class="contact-icon whatsapp">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
                        </svg>
                    </div>
                    <div class="contact-info">
                        <span class="contact-label">WHATSAPP</span>
                        <a href="https://wa.me/17252440993" target="_blank" class="contact-value">1(725)244-0993</a>
                    </div>
                    <button class="copy-btn" @click.stop="copyToClipboard('1(725)244-0993')">{{ langrage.copy }}</button>
                </div>
            </el-popover>

            <!-- Email -->
            <el-popover trigger="hover" placement="left" :offset="[60, 0]" width="auto">
                <template #reference>
                    <div class="contact-btn email">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                            <polyline points="22,6 12,13 2,6"/>
                        </svg>
                    </div>
                </template>
                <div class="contact-popover">
                    <div class="contact-icon email">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                            <polyline points="22,6 12,13 2,6"/>
                        </svg>
                    </div>
                    <div class="contact-info">
                        <span class="contact-label">EMAIL</span>
                        <span class="contact-value">Dealproxy@hotmail.com</span>
                    </div>
                    <button class="copy-btn" @click.stop="copyToClipboard('Dealproxy@hotmail.com')">{{ langrage.copy }}</button>
                </div>
            </el-popover>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import { ElMessage } from 'element-plus';
const langrage = inject('langrage');
const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        ElMessage.success({ message: 'Copied!', grouping: true });
    } catch (err) {
        console.error('Failed to copy:', err);
    }
};
</script>

<style lang="less" scoped>
.contact-float {
    position: fixed;
    right: 30px;
    bottom: 15rem;
    z-index: 9999;
}

.contact-btn-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 12px;
    border-radius: 24px;
    box-shadow: 0 8px 32px rgba(102, 126, 234, 0.4);
}

.contact-btn {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #fff;
    
    svg {
        width: 22px;
        height: 22px;
    }
    
    &:hover {
        transform: scale(1.1);
        filter: brightness(1.1);
    }
    
    &.facebook {
        background: #2B7FFF;
    }
    
    &.tg {
        background: #17ffd1;
    }
    
    &.whatsapp {
        background: #10B981;
    }
    
    &.email {
        background: #F59E0B;
    }
}

.contact-popover {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0px;
    min-width: 280px;
    max-width: 320px;
    box-sizing: border-box;
}

.contact-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    
    svg {
        width: 18px;
        height: 18px;
    }
    
    &.facebook {
        background: #2B7FFF;
        color: #fff;
    }
    
    &.tg {
        background: #17ffd1;
        color: #fff;
    }
    
    &.whatsapp {
        background: #10B981;
        color: #fff;
    }
    
    &.email {
        background: #F59E0B;
        color: #fff;
    }
}

.contact-info {
    flex: 1;
}

.contact-label {
    display: block;
    font-size: 10px;
    font-weight: 600;
    color: #9CA3AF;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.contact-value {
    display: block;
    font-size: 12px;
    color: #374151;
    text-decoration: none;
    
    &:hover {
        color: #2B7FFF;
        text-decoration: underline;
    }
}

.copy-btn {
    padding: 6px 12px;
    border: 1px solid #D1D5DB;
    border-radius: 6px;
    background: #fff;
    color: #6B7280;
    font-size: 11px;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
    
    &:hover {
        border-color: #2B7FFF;
        color: #2B7FFF;
        background: #F0F7FF;
    }
}
</style>